import type {RouteRecordRaw} from "vue-router";
import artistRouter from "@/router/modules/expand/artist";
import activityRouter from "@/router/modules/expand/activity";
import collaborationRouter from "@/router/modules/expand/collaboration";
import idleEnergyRouter from "@/router/modules/expand/idle-energy";
import socialRouter from "@/router/modules/expand/social";
import platformRouter from "@/router/modules/expand/platform";
import performRouter from "@/router/modules/expand/perform";

const customRouter: RouteRecordRaw[] =[
    artistRouter,
    activityRouter,
    collaborationRouter,
    idleEnergyRouter,
    socialRouter,
    platformRouter,
    performRouter,
]

export default customRouter;
